import {createSelector} from 'reselect';
import {content} from 'src/shared/content/selectors';
import {hashify} from 'src/pages/category/utils';

export const topics = createSelector(
  content,
  content => content.category.topics
);

export const selectedTopics = state => state.selectedTopics;

export const selectedTopic = createSelector(
  topics,
  selectedTopics,
  (topics, selectedTopics) => {
    const [topicName] = selectedTopics.split('/');
    if (topicName) {
      return topics.find(topic => hashify(topic.name) === topicName);
    }
  }
);

export const selectedSubtopic = createSelector(
  selectedTopic,
  selectedTopics,
  (selectedTopic, selectedTopics) => {
    const [, subtopicName] = selectedTopics.split('/');
    if (subtopicName) {
      return selectedTopic?.subtopics.find(subtopic => hashify(subtopic.name) === subtopicName);
    }
  }
);
